import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./DropDownMenu.scss";

const DropDownMenu = ({ setDropDown, toggleRef }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const { categories = [] } = useSelector((state) => state.category || {});
  const { subcategories = [] } = useSelector(
    (state) => state.subcategories || {}
  );
  const { subsubcategories = [] } = useSelector(
    (state) => state.subsubcategories || {}
  );

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        (!toggleRef?.current || !toggleRef.current.contains(event.target))
      ) {
        setDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setDropDown, toggleRef]);

  const handleNavigation = (id, type = "category") => {
    let path;
    if (type === "subcategory") {
      path = `/productss/${id}`;
    } else if (type === "subsubcategory") {
      path = `/items/${id}`;
    } else {
      path = `/products/${id}`;
    }
    navigate(path);
    setDropDown(false);
  };

  return (
    <div ref={dropdownRef} className="dropdownMenuContainer">
      <ul>
        {categories.map((category) => (
          <li
            key={category._id}
            onMouseEnter={() => setSelectedCategory(category._id)}
            onMouseLeave={() => setSelectedCategory(null)}
          >
            <div onClick={() => handleNavigation(category._id)}>
              <span>{category.name}</span>
            </div>
            {selectedCategory === category._id && subcategories.length > 0 && (
              <ul className="subCategoryList">
                {subcategories
                  .filter((subcat) =>
                    subcat.parentCategories.some(
                      (parent) => parent._id === category._id
                    )
                  )
                  .map((subcat) => (
                    <li
                      key={subcat._id}
                      onClick={() =>
                        handleNavigation(subcat._id, "subcategory")
                      }
                      onMouseEnter={() => setSelectedSubcategory(subcat._id)}
                      onMouseLeave={() => setSelectedSubcategory(null)}
                    >
                      <span>{subcat.name}</span>

                      {selectedSubcategory === subcat._id &&
                        subsubcategories.length > 0 && (
                          <ul className="subSubCategoryList">
                            {subsubcategories
                              .filter((subsubcat) =>
                                subsubcat.parentSubcategories.some(
                                  (parent) => parent._id === subcat._id
                                )
                              )
                              .map((subsubcat) => (
                                <li
                                  key={subsubcat._id}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleNavigation(
                                      subsubcat._id,
                                      "subsubcategory"
                                    );
                                  }}
                                >
                                  <span>{subsubcat.name}</span>
                                </li>
                              ))}
                          </ul>
                        )}
                    </li>
                  ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropDownMenu;
